import Container from '@/components/Container';
// import Link from '@/components/Link';

export default function TrainerListingLayout({ children }) {
  return (
    <div className="bg-gray-100">
      {/* <div className="bg-white shadow-sm">
        <Container>
          <div className="flex items-center relative -mb-px space-x-4 lg:space-x-6">
            <Link
              className="font-medium py-4 px-1 flex items-center border-b-2 border-transparent text-gray-500 hover:text-gray-900"
              href="/clases"
            >
              <div className="whitespace-nowrap hidden md:block">
                Calendario de entrenamientos
              </div>
              <div className="md:hidden">Calendario</div>
            </Link>
            <span className="font-medium py-4 px-1 flex items-center border-b-2 text-green-500 border-green-500">
              Entrenadores
            </span>
          </div>
        </Container>
      </div> */}
      <Container className="py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {children}
        </div>
      </Container>
    </div>
  );
}
